import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface ITitleComponentParams {
  title: string;
  route?: string | string[];
  more?: string;
  editRoute?: string | string[];
  editTitle?: string;
}

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent {
  @Input() public set title(title: string) {
    this._title = title;
  }
  public get title(): string {
    return this.params ? this.params.title : this._title;
  }
  @Input() public set route(route: string | string[]) {
    this._route = route;
  }
  public get route(): string | string[] {
    return this.params ? this.params.route : this._route;
  }
  @Input() public set more(more: string) {
    this._more = more;
  }
  public get more(): string {
    return this.params ? this.params.more : this._more;
  }
  @Input() public set editRoute(editRoute: string | string[]) {
    this._editRoute = editRoute;
  }
  public get editRoute(): string | string[] {
    return this.params ? this.params.editRoute : this._editRoute;
  }
  @Input() public set editTitle(editTitle: string) {
    this._editTitle = editTitle;
  }
  public get editTitle(): string {
    return this.params ? this.params.editTitle : this._editTitle;
  }
  @Input() params?: ITitleComponentParams;

  private _title: string;
  private _route: string | string[];
  private _more: string;
  private _editRoute: string | string[];
  private _editTitle: string;
}
